{
  "name": "bubble-bobble-remake",
  "private": true,
  "version": "0.3.1",
  "description": "A faithful remake of the 1987 Commodore 64 Bubble Bobble, drawn as low-resolution 3D pixel art",
  "type": "module",
  "scripts": {
    "dev": "vite",
    "build": "pnpm typecheck && vite build",
    "preview": "vite preview",
    "serve": "node server/index.mjs",
    "typecheck": "tsc --noEmit -p tsconfig.json && tsc --noEmit -p tsconfig.sim.json && tsc --noEmit -p tsconfig.node.json",
    "purity": "node tools/check-purity.mjs",
    "sizes": "node tools/check-file-sizes.mjs",
    "test": "vitest run",
    "test:watch": "vitest",
    "check": "pnpm typecheck && pnpm purity && pnpm sizes && pnpm test",
    "e2e": "playwright test",
    "e2e:update": "playwright test --update-snapshots"
  },
  "dependencies": {
    "three": "0.186.0"
  },
  "devDependencies": {
    "@playwright/test": "^1.63.0",
    "@types/node": "^22.20.4",
    "@types/three": "0.186.0",
    "typescript": "7.0.2",
    "vite": "8.3.0",
    "vitest": "5.0.1"
  }
}
